export default {
      ProductModels: '$MHF_ModelNameVal_$MHF|ProductModels',

};
